// extracted by mini-css-extract-plugin
export default {"layout":"_3B3wQNI5I7g5QfcXQW9LA1"};